import getTypeByTrigger from './utils/getTypeByTrigger';

const findMentionEntities = (trigger, mentionEntityTypes = []) => (
  contentBlock,
  callback,
  contentState
) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    const entityType = entityKey !== null ? contentState.getEntity(entityKey).getType() : null;
    return (entityType === getTypeByTrigger(trigger) || mentionEntityTypes.includes(entityType));
  }, callback);
};

export default findMentionEntities;
